import React from 'react';
import {
  ExpandableNavigationItem,
  ExpandableNavigationItemIcon,
  ExpandableNavigationItemIconProps,
  ExpandableNavigationItemLink,
  ExpandableNavigationItemLinkProps,
  ExpandableNavigationItemLogoProps,
  ExpandableNavigationItemText,
} from 'app/src/components/ExpandableNavigation';

import styles from './navigation.less';

export interface TeamTabProps
  extends ExpandableNavigationItemLogoProps,
    ExpandableNavigationItemLinkProps {
  billingUrl: string;
  displayName: string;
  expanded: boolean;
  orgId: string;
  linkTabs: TeamLinkSubTabProps[];
  selected: boolean;
}

interface TeamLinkSubTabProps
  extends ExpandableNavigationItemLinkProps,
    ExpandableNavigationItemIconProps {
  displayName: string;
  external?: boolean;
  selected: boolean;
}

export const TeamLinkSubTab: React.FunctionComponent<TeamLinkSubTabProps> = ({
  displayName,
  external,
  iconName,
  selected,
  ...props
}) => (
  <ExpandableNavigationItem>
    <ExpandableNavigationItemLink
      selected={selected}
      className={external ? styles.externalLink : ''}
      indented
      small
      quiet
      {...props}
    >
      <ExpandableNavigationItemIcon iconName={iconName} />
      <ExpandableNavigationItemText>{displayName}</ExpandableNavigationItemText>
      {external && (
        <ExpandableNavigationItemIcon
          iconName={'forward'}
          className={styles.externalIcon}
        />
      )}
    </ExpandableNavigationItemLink>
  </ExpandableNavigationItem>
);
